<template>
  <div id="natesForm">
    <bar-manut single-entity="Natureza" plural-entity="Naturezas" v-bind:crud="this.crud" v-on:closeform="closeForm"
      v-on:save="handleSave">
    </bar-manut>

    <validation v-if="errmessages.length != 0" :messages="errmessages"></validation>
    <div>
      <div class="default-container">
        <label-title title="Dados da Natureza"></label-title>
        <div class="row">
          <form-field v-model="nates.codnates" :metadata="metadata.nates.codnates" type="text" col="2" :disabled="true">
          </form-field>
        </div>
        <div class="row">
          <form-field v-model="nates.tpnat" type="select" col="4" :metadata="metadata.nates.tpnat"></form-field>
          <form-field v-model="nates.tpnf" type="select" col="4" :metadata="metadata.nates.tpnf"></form-field>
          <form-field v-model="nates.movfisica" type="select" col="4" :metadata="metadata.nates.movfisica"></form-field>
        </div>
        <div class="row">
          <form-field ref="descricao" v-model="nates.descricao" type="text" col="6" :metadata="metadata.nates.descricao"
            name="descricao" :v-errors="errors" v-validate="metadata.nates.descricao.validator"></form-field>
          <!-- CFOP ENTRADA -->
          <form-field v-if="nates.tpnat == 'E'" v-model="nates.cfop" type="select2" col="6"
            :metadata="metadata.nates.cfop" :select2="{ entity: 'cfop/entradas', minlength: 0 }" name="cfop"
            :v-errors="errors" v-validate="metadata.nates.cfop.validator"></form-field>
          <!-- CFOP SAIDA OBRIGATORIA -->
          <form-field v-if="nates.tpnat == 'S'" v-model="nates.cfop" type="select2" col="6"
            :metadata="metadata.nates.cfop" :select2="{ entity: 'cfop/saidas', minlength: 0 }" name="cfop"
            :v-errors="errors" v-validate="metadata.nates.cfop.validator"></form-field>
          <!-- <form-field v-model="nates.stnates" type="select" col="2" :metadata="metadata.nates.stnates"></form-field> -->
        </div>
        <div class="row">
          <form-field
            v-if="exibirCalculaDuplicata"
            v-model="nates.calcdup" type="select" col="4" :metadata="metadata.nates.calcdup"></form-field>
          <!-- <form-field v-if="nates.tpnf=='V' && nates.calcdup=='S' && nates.tpnat=='S'" v-model="nates.calccomi" type="select" col="2" :metadata="metadata.nates.calccomi"></form-field> -->
          <!-- <form-field v-if="nates.tpnf=='V' && nates.calcdup=='S' && nates.tpnat=='S'" v-model="nates.calcreten" type="select" col="2" :metadata="metadata.nates.calcreten"></form-field> -->
          <!-- <form-field v-model="nates.movterc" type="select" col="2" :metadata="metadata.nates.movterc"></form-field> -->
        </div>
        <div v-if="nates.tpnat == 'E'">
          <label-title title="Impostos na Entrada"></label-title>
          <div class="row">
            <form-field v-if="nates.tpnf == 'C'" v-model="nates.finentrada" type="select" col="2"
              :metadata="metadata.nates.finentrada"></form-field>
            <!-- <form-field v-model="nates.creicm" type="select" col="2" :metadata="metadata.nates.creicm"></form-field>
            <form-field v-model="nates.creipi" type="select" col="2" :metadata="metadata.nates.creipi"></form-field>
            <form-field v-model="nates.crepis" type="select" col="2" :metadata="metadata.nates.crepis"></form-field>
            <form-field v-model="nates.crecofins" type="select" col="2" :metadata="metadata.nates.crecofins"></form-field> -->
            <!-- campo utilizado somente em sped
            <form-field v-if="nates.crepis == 'S' || nates.crecofins == 'S'" v-model="nates.bcpiscofins" type="select2"
              col="4" :metadata="metadata.nates.bcpiscofins" name="bcpiscofins" :v-errors="errors"
              v-validate="metadata.nates.bcpiscofins.validator"></form-field> -->
            <form-field v-if="cfopImportacao" v-model="nates.calcii" type="select" col="2"
              :metadata="metadata.nates.calcii"></form-field>
            <form-field v-model="nates.aii" type="value" col="2" :metadata="metadata.nates.aii" :precision="6"
              v-if="cfopImportacao && nates.calcii == 'S'" name="aii" :v-errors="errors"
              v-validate="metadata.nates.aii.validator"></form-field>
            <!-- <form-field v-model="nates.acabados" type="select" col="2" :metadata="metadata.nates.acabados"></form-field> -->
            <!-- <form-field v-model="nates.bonif" type="select" col="2" :metadata="metadata.nates.bonif"></form-field> -->
          </div>
          <!-- <div class="row">
            <form-field v-model="nates.calcicm" type="select" col="4" :metadata="metadata.nates.calcicm"></form-field>
          </div> -->
          <div class="row">
            <form-field v-model="nates.sticm" type="select2" col="4" :metadata="metadata.nates.sticm" name="sticm"
              :v-errors="errors" v-validate="metadata.nates.sticm.validator"></form-field>
          </div>
          <div class="row">
            <form-field v-model="nates.csosn" type="select2" col="6" :metadata="metadata.nates.csosn" name="csosn"
              :v-errors="errors" v-validate="metadata.nates.csosn.validator"></form-field>
          </div>
          <div class="row">
            <form-field v-model="nates.stipi" type="select2" col="4" :metadata="metadata.nates.stipi" name="stipi"
              :v-errors="errors" v-validate="metadata.nates.stipi.validator"
              :select2="{ entity: 'stipi/entradas', minlength: 0 }"></form-field>
            <form-field v-model="nates.ipidevol" type="select" col="4" :metadata="metadata.nates.ipidevol"
              v-if="nates.stipi == '49' || nates.stipi == '00'"></form-field>
          </div>
          <div class="row">
            <form-field v-model="nates.stpis" type="select2" col="4" :metadata="metadata.nates.stpis" name="stpis"
              :v-errors="errors" v-validate="metadata.nates.stpis.validator"
              :select2="{ entity: 'stpiscofins/entradas', minlength: 0 }"></form-field>
          </div>
          <div class="row">
            <form-field v-model="nates.stcofins" type="select2" col="4" :metadata="metadata.nates.stcofins"
              name="stcofins" :v-errors="errors" v-validate="metadata.nates.stcofins.validator"
              :select2="{ entity: 'stpiscofins/entradas', minlength: 0 }"></form-field>
          </div>

          <!-- campo utilizado somente em sped
          <div class="row">
            <form-field v-model="nates.natfrete" type="select2" col="4" :metadata="metadata.nates.natfrete"
              name="natfrete" :v-errors="errors" v-validate="metadata.nates.natfrete.validator"></form-field>
          </div> -->
        </div>

        <div v-if="nates.tpnat == 'S'">
          <label-title title="ICMS"></label-title>
          <div class="row">
            <form-field v-model="nates.calcicm" type="select" col="4" :metadata="metadata.nates.calcicm"></form-field>
            <form-field v-model="nates.sticm" type="select2" col="4" :metadata="metadata.nates.sticm" name="sticm"
              :v-errors="errors" v-validate="metadata.nates.sticm.validator"></form-field>
            <form-field v-model="nates.csosn" type="select2" col="6" :metadata="metadata.nates.csosn" name="csosn"
              :v-errors="errors" v-validate="metadata.nates.csosn.validator"></form-field>
          </div>
          <div class="row">
            <form-field v-model="nates.calcst" type="select" col="4" :metadata="metadata.nates.calcst"></form-field>
            <form-field v-model="nates.calcicmfre" type="select" col="4" :metadata="metadata.nates.calcicmfre">
            </form-field>
            <form-field v-model="nates.calcicmdesp" type="select" col="4" :metadata="metadata.nates.calcicmdesp">
            </form-field>
          </div>
          <div class="row">
            <form-field v-model="nates.calcaprovcred" type="select" col="4" :metadata="metadata.nates.calcaprovcred"
              v-if="nates.tpnf == 'V' || nates.tpnf == 'I' "></form-field>
            <form-field v-model="nates.calcdesicm" type="select" col="4" :metadata="metadata.nates.calcdesicm"
              v-if="nates.tpnf == 'V'"></form-field>
            <form-field v-model="nates.pdesicm" type="value" col="4" :metadata="metadata.nates.pdesicm" :precision="2"
              v-if="nates.calcdesicm == 'S'" name="pdesicm" :v-errors="errors"
              v-validate="metadata.nates.pdesicm.validator"></form-field>
          </div>
          <div class="row">
            <form-field v-model="nates.motdesicm" type="select2" col="4" :metadata="metadata.nates.motdesicm"
              name="motdesicm" v-if="nates.tpnf == 'V'"></form-field>
            <form-field v-model="nates.soma_icmdeson_nf" type="select" col="4"
              :metadata="metadata.nates.soma_icmdeson_nf" v-if="nates.tpnf == 'V'"></form-field>
          </div>
          <label-title title="Cálculo de IPI"></label-title>
          <div class="row">
            <form-field v-model="nates.calcipi" type="select" col="4" :metadata="metadata.nates.calcipi"></form-field>
            <form-field v-model="nates.cenqipi" type="number" col="4" :metadata="metadata.nates.cenqipi" name="cenqipi"
              :v-errors="errors" v-validate="metadata.nates.cenqipi.validator"></form-field>
            <form-field v-model="nates.calcipifre" type="select" col="4" :metadata="metadata.nates.calcipifre">
            </form-field>
          </div>
          <div class="row">
            <form-field v-model="nates.calcipidesp" type="select" col="4" :metadata="metadata.nates.calcipidesp">
            </form-field>
            <form-field v-if="nates.calcipi == 'N'" v-model="nates.stipi" type="select2" col="4"
              :metadata="metadata.nates.stipi" name="stipi" :v-errors="errors"
              v-validate="metadata.nates.stipi.validator" :select2="{ entity: 'stipi/saidas', minlength: 0 }">
            </form-field>
          </div>
          <div class="row">
            <form-field v-model="nates.ipidevol" type="select" col="4" :metadata="metadata.nates.ipidevol"
              v-if="nates.stipi == '50' || nates.stipi == '99'"></form-field>
          </div>
          <label-title title="Cálculo de PIS e COFINS"></label-title>
          <div class="row">
            <form-field v-model="nates.calcpis" type="select" col="4" :metadata="metadata.nates.calcpis"></form-field>
            <form-field v-if="nates.calcpis == 'N'" v-model="nates.stpis" type="select2" col="4"
              :metadata="metadata.nates.stpis" name="stpis" :v-errors="errors"
              v-validate="metadata.nates.stpis.validator" :select2="{ entity: 'stpiscofins/saidas', minlength: 0 }">
            </form-field>
            <!-- <form-field v-model="nates.apis" type="value" col="2" :metadata="metadata.nates.apis" :precision="6"
                        name="apis" :v-errors="errors" v-validate="metadata.nates.apis.validator"></form-field> -->
          </div>
          <div class="row">
            <form-field v-model="nates.calccofins" type="select" col="4" :metadata="metadata.nates.calccofins">
            </form-field>
            <form-field v-if="nates.calccofins == 'N'" v-model="nates.stcofins" type="select2" col="4"
              :metadata="metadata.nates.stcofins" name="stcofins" :v-errors="errors"
              v-validate="metadata.nates.stcofins.validator" :select2="{ entity: 'stpiscofins/saidas', minlength: 0 }">
            </form-field>
            <!-- <form-field v-model="nates.acofins" type="value" col="2" :metadata="metadata.nates.acofins" :precision="6"
                        name="acofins" :v-errors="errors" v-validate="metadata.nates.acofins.validator"></form-field> -->
            <form-field v-if="nates.tpnf == 'V'" v-model="nates.calcdespc" type="select" col="4"
              :metadata="metadata.nates.calcdespc"></form-field>
          </div>
          <div class="row">
            <form-field v-model="nates.pdespc" type="value" col="4" :metadata="metadata.nates.pdespc" :precision="2"
              v-if="nates.calcdespc == 'S'" name="pdespc" :v-errors="errors"
              v-validate="metadata.nates.pdespc.validator"></form-field>
          </div>
        </div>
        <label-title title="Outras Informações"></label-title>
        <div class="row">
          <!-- <form-field v-model="nates.integracont" type="select" col="2" :metadata="metadata.nates.integracont"></form-field>
                <form-field v-model="nates.integrafis" type="select" col="2" :metadata="metadata.nates.integrafis"></form-field>
                <form-field v-model="nates.ativofixo" type="select" col="2" :metadata="metadata.nates.ativofixo"></form-field>
                <form-field v-if="nates.tpnat=='S' && (nates.tpnf=='F'||nates.tpnf=='R')" v-model="nates.tpcustonates" type="select" col="2" :metadata="metadata.nates.tpcustonates"></form-field> -->
        </div>
        <div class="row">
          <form-field v-model="nates.codmennf1" type="select2" col="4" :metadata="metadata.nates.codmennf1"
            name="codmennf1" :v-errors="errors" v-validate="metadata.nates.codmennf1.validator"></form-field>
          <form-field v-model="nates.codmennf2" type="select2" col="4" :metadata="metadata.nates.codmennf2"
            name="codmennf2" :v-errors="errors" v-validate="metadata.nates.codmennf2.validator"></form-field>
          <form-field v-model="nates.codmennf3" type="select2" col="4" :metadata="metadata.nates.codmennf3"
            name="codmennf3" :v-errors="errors" v-validate="metadata.nates.codmennf3.validator"></form-field>
          <!-- <form-field v-model="nates.codmennf4" type="select2" col="3" :metadata="metadata.nates.codmennf4"
                    name="codmennf4" :v-errors="errors" v-validate="metadata.nates.codmennf4.validator"></form-field> -->
        </div>

        <label-title title="Impostos Unificados (IBS e CBS)"></label-title>
        <div class="row">
          <form-field v-model="nates.natescclass" type="select2" col="4" :metadata="metadata.nates.natescclass"
            :disabled="isView" name="natescclass" :v-errors="errors" v-validate="metadata.nates.natescclass.validator"
            parent="mymodal" :select2="{ entity: 'ivaclass', minlength: 0 }"></form-field>
          <form-field v-model="nates.ivatributacao" type="select" col="4" :metadata="metadata.nates.ivatributacao"
            name="sticm" :v-errors="errors" v-validate="metadata.nates.ivatributacao.validator"></form-field>
          <form-field v-model="nates.natesccredpres" type="select" col="6" :metadata="metadata.nates.natesccredpres"
            name="natesccredpres" :v-errors="errors" v-validate="metadata.nates.natesccredpres.validator"></form-field>
        </div>

      </div>
    </div>

  </div>
</template>

<script>

import { SysVars } from '../main'
import { apiORDSpost, apiORDSdelete } from '../shared/api-functions'

export default {
  props: {
    index: '',
    crud: '',
  },

  data() {
    return {
      crudText: '',
      nates: { ...this.$store.getters.getEntities.nates },
      metadata: this.$store.getters.getEntities.metadata,
      errmessages: [],  //armazena as mensagens de validacao do servidor para mostrar em tela
      unwatch: true,
    }
  },

  computed: {
    finentrada: function () {
      return this.nates.finentrada
    },

    cfop: function () {
      return this.nates.cfop
    },

    tpnf: function () {
      return this.nates.tpnf
    },

    tpnat: function () {
      return this.nates.tpnat
    },

    csosn: function () {
      return this.nates.csosn
    },

    sticm: function () {
      return this.nates.sticm
    },

    cfopImportacao: function () {
      return this.nates.cfop > '3000' && this.nates.cfop < '5000'
    },

    exibirCalculaDuplicata: function () {
      const tiposExibicao = ['V', 'C', 'S', 'I', 'D', 'CR', 'DB']
      return tiposExibicao.includes(this.nates.tpnf)
    }
  },

  watch: {
    tpnat: function (newValue) {
      this.$nextTick(function () {
        jQuery('[data-toggle="tooltip"]').tooltip()
      })
      if (this.nates.tpnat == 'E' && this.nates.tpnf == 'V')
        this.nates.tpnf = 'C'
      if (this.nates.tpnat == 'S' && this.nates.tpnf == 'C')
        this.nates.tpnf = 'V'

      if (!this.stipi && this.nates.tpnat == 'E')
        this.sticm = '03'

      // this.metadata.nates.sticm.validator.required = (newValue == 'S')
      // this.metadata.nates.csosn.validator.required = (newValue == 'S')
      this.metadata.nates.sticm.validator.required = false
      this.metadata.nates.csosn.validator.required = false

      // this.metadata.nates.motdesicm.validator = this.metadata.nates.motdesicm.validator ? this.metadata.nates.motdesicm.validator : {}
      // this.metadata.nates.motdesicm.validator.required = false
      this.$validator.reset();
    },

    finentrada: function (newValue, oldValue) {
      if (this.unwatch) {
        return
      }
      if (newValue == '1' || newValue == '2') {
        this.nates.creicm = 'S'
        this.nates.creipi = 'S'
        this.nates.crepis = 'S'
        this.nates.crecofins = 'S'
      } else {
        this.nates.creicm = 'N'
        this.nates.creipi = 'N'
        this.nates.crepis = 'N'
        this.nates.crecofins = 'N'
      }
    },

    cfop: function () {
      if (this.unwatch) {
        return
      }
      if (this.nates.cfop < '4000') {
        this.nates.tpnat = 'E'
        this.nates.sticm = '90'
        this.nates.csosn = '900'
        if (this.nates.cfop == '1101') {  //compra para industr
          this.nates.finentrada = '1'
        } else
          if (this.nates.cfop == '1102') { //compra para comercializacao
            this.nates.finentrada = '2'
          } else
            if (this.nates.cfop == '1556') { //compra para consumo
              this.nates.finentrada = '3'
            } else
              if (this.nates.cfop == '1551') { //compra de ativo
                this.nates.finentrada = '4'
              } else {
                this.nates.finentrada = '5' //outras
              }
      } else {
        this.nates.tpnat = 'S'
        this.nates.finentrada = null
      }
    },

    'nates.stipi': function () {
      if (this.nates.stipi != '50' && this.nates.stipi != '99' &&
        this.nates.stipi != '00' && this.nates.stipi != '49') {
        this.nates.ipidevol = 'N';
      }
    }

  },

  methods: {
    closeForm() {
      this.$emit('closeform', this.nates.codnates)
    },

    handleSave() {
      //BOTAO SALVAR

      if (this.nates.cfop != null) {
        if (this.nates.tpnat == 'E' && this.nates.cfop > 4000) {
          this.$erpToastError('CFOP inválida para operações de entrada')
          return
        }
        if (this.nates.tpnat == 'S' && this.nates.cfop < 5000) {
          this.$erpToastError('CFOP inválida para operações de saída')
          return
        }
      }
      if (this.nates.cfop == null && this.nates.tpnf != 'O') {
        this.$erpToastError('Campo CFOP é obrigatório para o tipo de nota selecionado')
        return
      }

      this.$validator.validateAll().then(isValid => {
        if (!isValid) {
          this.$erpToastError('Por favor, corrija os campos em destaque para continuar')
        } else {
          this.apiPost()
        }
      })
    },

    async loadData() {
      //carrega o item para alteracao ou visualizacao
      await this.$store.dispatch('loadNates', { id: this.index })
      if (this.$store.getters.getNates) {
        this.nates = { ...this.$store.getters.getNates }
      }
      this.$nextTick(function () {
        jQuery('[data-toggle="tooltip"]').tooltip()
      })

      //HABILITAR WATCH
      var vm = this
      setTimeout(function () {
        vm.unwatch = false
      }, 1000)

    },

    async apiDelete(del) {
      //efetua a exclusao da natureza

      var modulo = 'cg/nates/' + this.nates.codnates
      var sendData = {}

      const data = await apiORDSdelete(this.$store, modulo)
      this.$erpToastDeleted()
      this.closeForm()
    },

    async apiPost() {
      //efetua a gravacao do item

      var modulo = 'cg/nates/'
      var sendData = {}

      sendData = { nates: this.nates }

      let metodo = 'post'
      let update = false
      if (this.crud != SysVars.crudI) {
        metodo = 'put'
        update = true
      }

      const data = await apiORDSpost(this.$store, modulo, sendData, metodo)
      if (data.errmessages) {
        this.errmessages = data.errmessages
        this.$erpToastError('Alguns erros precisam ser corrigidos.')
      } else {
        if (update) {
          this.$erpToastUpdated()
        } else {
          this.$erpToastInserted()
        }
        if (data.items) {
          this.nates = data.items[0]
        }
        this.errmessages = {}
        this.closeForm()
      }
    },

  },

  components: {

  },

  beforeCreate() {

  },


  created() {
    this.$nextTick(function () {
      jQuery('[data-toggle="tooltip"]').tooltip()
    })

    this.metadata.nates.cfop.validator = { required: true }

    this.crudText = this.$crudText(this.crud)

    if (this.crud == SysVars.crudI) {
      this.nates.tpnat = 'S'
      this.nates.stnates = 'A'
      this.nates.calcicm = 'N'
      this.nates.calcicmfre = 'S'
      this.nates.calcicmdesp = 'S'
      this.nates.calcdesicm = 'N'
      this.nates.calcst = 'N'
      this.nates.calcipi = 'N'
      this.nates.calcipifre = 'N'
      this.nates.calcipidesp = 'N'
      this.nates.calcpis = 'N'
      this.nates.calccofins = 'N'
      this.nates.calcdespc = 'N'
      this.nates.calcii = 'N'
      this.nates.creicm = 'N'
      this.nates.crepis = 'N'
      this.nates.crecofins = 'N'
      this.nates.creipi = 'N'
      this.nates.movfisica = 'S'
      this.nates.ativofixo = 'N'
      this.nates.integrafis = 'S'
      this.nates.integracont = 'S'
      this.nates.tpcustonates = 'P'
      this.nates.calcreten = 'N'
      this.nates.tpnf = 'V'
      this.nates.calcdup = 'S'
      this.nates.calccomi = 'N'
      this.nates.movest = 'S'
      this.nates.movterc = 'N'
      this.nates.calcdescicm = 'N'
      this.nates.calcaprovcred = 'N'
      this.nates.bonif = 'N'
      this.nates.consumo = 'N'
      //this.setWatch()
    } else {
      this.loadData()
    }
    this.$nextTick(function () {
      this.$refs.descricao.focus()
    })
  }

}

</script>

<style>

</style>



// WEBPACK FOOTER //
// src/forms/nates-form.vue